<div class="most-relevant-item-short-header">
  <div class="most-relevant-item-short-header-button-container">
    <app-action-button (click)="goToHelpItem()">{{ 'help-items.go-to-item' | translate }}</app-action-button>
  </div>

  <app-most-relevant-item-description [description]="item().description" />
  @if (item().links?.length) {
    <app-most-relevant-item-links [links]="item().links" />
  }
</div>
@if (item().addOns?.length) {
  <app-most-relevant-item-add-ons [addOns]="item().addOns" [countryFilter]="countryFilter()" />
}
